import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getFeaturedTours } from "../../../../api/website/tour/tourAPI";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router";

const FeaturedTours = () => {
  const [FormData, setFormData] = useState([]);
  useEffect(() => {
    getFeaturedTours(setFormData);
  }, []);
  return (
    <>
      {FormData.length > 0 && (
        <div className="p-5 border rounded-lg">
          {FormData && FormData.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {FormData.map((item, index) => {
                return (
                  <Link
                    key={index}
                    to={`/tour/details/${item.id}/${item.tourName
                      .toLowerCase()
                      .replace(/ /g, "-")}`}
                  >
                    <div className="border rounded-lg overflow-hidden shadow-lg w-full h-[400px] relative cursor-pointer scale-100 hover:scale-105 transition-transform duration-300">
                      <img
                        src={item?.images[0]}
                        alt={item.tourName}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-slate-50/10"></div>
                      <div className="absolute bottom-0 z-30 w-full">
                        <div className="p-3">
                          <div>
                            <p className="text-sm text-white font-bold">
                              {item.tourName}
                            </p>
                          </div>
                          <div className="flex justify-start items-start gap-1 py-2">
                            <FaMapMarkerAlt className="text-xs text-white" />
                            <p className="text-xs text-white">
                              {item.city}, {item.country}
                            </p>
                          </div>
                          <div className="flex flex-col gap-1 justify-end items-end ">
                            {item.discount !== 0 && (
                              <p className="text-sm text-white px-2 py-0.5 border rounded-full">
                                {item.discount}% off
                              </p>
                            )}
                            <p className="text-lg text-white font-bold">
                              {(
                                item.price -
                                (item.price * item.discount) / 100
                              ).toFixed(0)}{" "}
                              BDT
                            </p>
                            {item.discount !== 0 && (
                              <p className="text-sm text-white line-through">
                                {item.price} BDT
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="absolute top-2 right-2 z-50">
                        <p className="text-xs text-white px-3 py-1 border rounded-full">
                          feautured
                        </p>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {[...Array(4)].map((_, index) => (
                <div
                  key={index}
                  className="border rounded-lg overflow-hidden shadow-lg w-full h-[400px] relative animate-pulse"
                >
                  <div className="w-full h-full bg-slate-200"></div>

                  <div className="absolute inset-0 bg-gradient-to-t from-slate-300 to-slate-100/20"></div>

                  <div className="absolute bottom-0 w-full p-3 space-y-2">
                    <div className="h-4 w-3/4 bg-slate-300 rounded"></div>
                    <div className="h-3 w-1/2 bg-slate-300 rounded"></div>

                    <div className="flex flex-col items-end gap-2 mt-2">
                      <div className="h-5 w-16 bg-slate-300 rounded-full"></div>
                      <div className="h-6 w-24 bg-slate-300 rounded"></div>
                      <div className="h-4 w-20 bg-slate-300 rounded"></div>
                    </div>
                  </div>

                  <div className="absolute top-2 right-2 h-6 w-20 bg-slate-300 rounded-full"></div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FeaturedTours;
